import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import Convert from 'common/utils/convert-svg-to-png'
import Filter from 'common/components/responsive/filter'


const Fonts = ({
   siteName,
   value,
   onChange,
}) => {
   const [loadingFont, setLoadingFont] = useState(true)
   const [fontList, setFontList] = useState([])
   const [currentFont, setCurrentFont] = useState({ name: null, font: null })

   useEffect(() => {
      onLoadFont()
   // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [])

   useEffect(() => {
      setCurrentFont({ name: value?.section_headers_font_family_name, font: value?.section_headers_font_family })
   // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [value])


   function onLoadFont(){
      setLoadingFont(true)
      const text = siteName?.charAt(0).toUpperCase() + siteName?.slice(1)
      Convert.getGoogleFonts(text, (data) => {
         setFontList(data)
         setLoadingFont(false)
      })

   }

   return (
      <div className='flex flex-col gap-2'>
         <p className='font-medium text-major'>Customize section headers</p>
         <Filter
            name={ !currentFont?.name ? 'Fonts' : '' }
            type='sort'
            data={ fontList }
            className='hover:bg-hover h-10 flex-0'
            height='10'
            desktopType='desktop'
            onFilterChange={ (value, name) => {
               // setCurrentFont({ name, font: value })
               onChange('all_section', { section_headers_font_family_name: name, section_headers_font_family: value, siteName }, 'fonts')
            }  }
            filterValueKey='font'
            onClickShowResult={ () => {} }
            activeSelectedValue={ {
               name: currentFont?.name,
               value: currentFont?.font,
            } }
            showNewStyles
            hasClearButton={ false }
            contentClassName={ `min-h-[30vh] ms:min-h-[100%] max-h-[400px] ` }
            isLoadinngData={ loadingFont }
            contentStyles={ { width: '100%',  top: '44px', left: '0' } }
            // activeValueWrapperClassName='flex-0'
            textInlineStyles={ {
               fontFamily: currentFont?.font || '',
               // width: '100%',
            } }
         />
      </div>
   )
}

Fonts.propTypes = {
   siteName: PropTypes.any,
   section_headers_font_family_name: PropTypes.any,
   section_headers_font_family: PropTypes.any,
   value: PropTypes.object,
   onChange: PropTypes.func,
}

export default Fonts

